module.exports = __webpack_public_path__ + "img/disponible.658237ed.png";